/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, {
    useCallback, useState, useContext, useEffect
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {
    ModalNextProvider
} from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { messages as commonMessages } from 'gw-platform-translations';
// import { claimsMessages } from 'gw-capability-claim-react';
// import { useDependencies } from 'gw-portals-dependency-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { FileUtil } from 'gw-portals-util-js';
import { ServiceRequestService } from 'gw-capability-servicerequest';
import messages from './UploadDocument.messages';
import metadata from './UploadComponent.metadata.json5';
import styles from './UploadComponent.module.scss';

function UploadComponent(props) {
    const {
        path: invoiceVM,
        // updatePath: updateWizardData,
        authHeader,
        uploadDocumentTypes,
        existingDocuments,
        serviceRequestID,
        setInvoiceVM,
        vendorDocumentType,
        setInvoiceDocValidated,
        refreshData
    } = props;

    const [selectedIcon, setSelectedIcon] = useState(-1);
    const [showLoader, setShowLoader] = useState(false);
    const [uploadedDocuments, setUploadedDocuments] = useState([]);
    const translator = useContext(TranslatorContext);

    useEffect(() => {
        _.set(invoiceVM, 'documentCheckList_Ext.value', uploadDocumentTypes);
    // only execute once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const iconMap = {
        Assessor_Report: 'mi-assignment',
        Investigators_Report_Ext: 'mi-find-in-page',
        Clearance_Certificate_Ext: 'mi-thumb-up-alt',
        Loss_Adjuster_Report_Ext: 'mi-assignment',
        Quantity_Surveyor_Report_Ext: 'mi-broken-image',
        Engineers_Report_Ext: 'mi-compare',
        Architecture_Report_Ext: 'mi-domain-disabled',
        Fee_invoice: 'mi-attach-file',
        Reinstatement_Invoice: 'mi-attach-file',
        Repair_Invoice: 'mi-attach-file',
        Salvage_Tender_Documents_Ext: 'mi-attach-file',
    };

    const fileMimeTypeMap = {
        csv: 'application/csv',
        doc: 'application/msword',
        msg: 'application/vnd.ms-outlook',
        eml: 'message/rfc822',
        zip: 'application/x-zip-compressed',
        pdf: 'application/pdf',
        ps: 'application/postscript',
        rtf: 'application/rtf',
        xls: 'application/vnd.ms-excel',
        ppt: 'application/vnd.ms-powerpoint',
        pps: 'application/vnd.ms-powerpoint',
        pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        wav: 'audio/wav',
        wma: 'audio/x-ms-wma',
        bmp: 'image/bmp',
        gif: 'image/gif',
        jpg: 'image/jpeg',
        tiff: 'image/tiff',
        tif: 'image/tiff',
        mdi: 'image/vnd.ms-modi',
        png: 'image/png',
        html: 'text/html',
        htm: 'text/html',
        txt: 'text/plain',
        rtx: 'text/richtext',
        xml: 'text/xml',
        mpg: 'video/mpeg',
        mpeg: 'video/mpeg',
        mov: 'video/quicktime',
        avi: 'video/x-msvideo',
        mp4: 'video/mp4'
    };

    const getFileExtension = useCallback((name) => {
        const extension = name.split('.').pop();
        return extension || '';
    }, []);

    const getMimeType = useCallback((name) => {
        const fileExtension = getFileExtension(name);
        let mimeType = _.get(fileMimeTypeMap, fileExtension);
        if (_.isNil(mimeType)) {
            mimeType = 'application/octet-stream';
        }
        return mimeType;
    }, [fileMimeTypeMap, getFileExtension]);

    const setItemVisibility = useCallback(
        (item) => {
            if (_.isNil(item)) {
                return false;
            }
            if (selectedIcon === -1) {
                return true;
            }
            return item.description === uploadDocumentTypes[selectedIcon].sasriaForm;
        },
        [uploadDocumentTypes, selectedIcon]
    );

    const getFileIcon = useCallback((extension) => {
        switch (extension) {
            case 'doc':
            case 'docx':
            case 'txt':
            case 'docm':
                return 'file-word';
            case 'xlt':
            case 'xlsx':
            case 'xlsm':
            case 'xls':
                return 'file-excel';
            case 'gif':
            case 'png':
            case 'jpeg':
                return 'file-image';
            case 'pdf':
                return 'file-pdf';
            default:
                return 'file';
        }
    }, []);

    const changeUploadDocmentImageType = useCallback(
        (documentUploadItem) => {
            const extension = getFileExtension(documentUploadItem.docUID).toLowerCase() || '';
            return `${getFileIcon(extension)}`;
        },
        [getFileExtension, getFileIcon]
    );

    const handleDocumentDownload = useCallback(
        (item) => {
            if (_.isNil(item)) {
                return null;
            }
            const { workingPublicID, sessionID } = item;
            return ServiceRequestService.downloadDocumentLink(workingPublicID, sessionID);
        },
        []
    );

    const handleError = useCallback(
        (title, message) => {
            return ModalNextProvider.showAlert({
                title: title,
                message: message,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        }, []
    );

    const updateUploadedDocuments = useCallback((documentType, publicID) => {
        const docs = _.get(uploadedDocuments, documentType, []);
        docs.push(publicID);
        _.set(uploadedDocuments, documentType, docs);
        const docTypeSize = uploadDocumentTypes ? uploadDocumentTypes.length : 0;
        let docValidated = false;
        if (docTypeSize === 1) {
            const doc1Type = _.get(uploadDocumentTypes[0], 'sasriaForm');
            const doc1Size = _.get(uploadedDocuments, doc1Type, []).length;
            docValidated = (doc1Size >= 1);
        } else if (docTypeSize === 2) {
            const doc1Type = _.get(uploadDocumentTypes[0], 'sasriaForm');
            const doc1Size = _.get(uploadedDocuments, doc1Type, []).length;
            const doc2Type = _.get(uploadDocumentTypes[1], 'sasriaForm');
            const doc2Size = _.get(uploadedDocuments, doc2Type, []).length;
            docValidated = (doc1Size >= 1 && doc2Size >= 1);
        }
        setUploadedDocuments(uploadedDocuments);
        setInvoiceDocValidated(docValidated);
    }, [uploadedDocuments, uploadDocumentTypes, setInvoiceDocValidated]);

    const onDeleteDocumentIcon = useCallback(
        (e, item) => {
            e.preventDefault();
            const { publicID, name } = item;
            ModalNextProvider.showConfirm({
                title: messages.confirmationToRemoveTitle,
                message: translator(messages.confirmationToRemoveMessage, { documentName: name }),
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.removeConfirmationYes,
                cancelButtonText: messages.removeConfirmationNo
            }).then(async (results) => {
                if (results === 'cancel') {
                    return _.noop();
                }
                setShowLoader(true);
                try {
                    // const isDeleteItem = await ClaimService.claimsRemoveDocument(
                    //     [claimNumber, publicID],
                    //     authHeader
                    // );
                    // if (isDeleteItem === false) {
                    //     setShowLoader(false);
                    //     return handleError(
                    //         claimsMessages.deletionFailedTitle,
                    //         claimsMessages.deletionFailedMessage
                    //     );
                    // }
                    const documentsArray = _.get(invoiceVM, 'documents.value');
                    const updatedDocArray = documentsArray.filter((documentObj) => {
                        return documentObj.publicID !== publicID;
                    });
                    // const newInvoiceVM = _.clone(invoiceVM);
                    _.set(invoiceVM, 'documents.value', updatedDocArray);
                    refreshData();
                    setShowLoader(false);
                    return true;
                } catch (documentDeletionError) {
                    setShowLoader(false);
                    return handleError(
                        messages.removeServiceFailedTitle,
                        messages.removeServiceFailedMessage
                    );
                }
            }, _.noop);
        },
        [translator, invoiceVM, refreshData, handleError]
    );

    const showDocumentDeleteIcon = useCallback((documentUploadItem) => {
        if (documentUploadItem.canDelete) {
            return true;
        }
        return false;
    }, []);

    const generateMoreInfoDocumentsOverrides = useCallback(() => {
        const documentUploadPath = 'value.documents';
        const documentUploadItems = _.get(invoiceVM, documentUploadPath, []);
        const overrides = documentUploadItems.map((documentUploadItem, index) => {
            return {
                [`uploadDocumentItem${index}`]: {
                    visible: setItemVisibility(documentUploadItem)
                },
                [`documentLeftSection${index}`]: {
                    icon: changeUploadDocmentImageType(documentUploadItem)
                },
                [`documentNameLink${index}`]: {
                    href: handleDocumentDownload(documentUploadItem)
                },
                [`documentDeleteSection${index}`]: {
                    onClick: (e) => {
                        onDeleteDocumentIcon(e, documentUploadItem);
                    }
                },
                [`documentDeleteIcon${index}`]: {
                    visible: showDocumentDeleteIcon(documentUploadItem)
                }
            };
        });
        return Object.assign({}, ...overrides);
    }, [changeUploadDocmentImageType, handleDocumentDownload, invoiceVM, onDeleteDocumentIcon, setItemVisibility, showDocumentDeleteIcon]);

    const getDescription = useCallback(
        (index) => {
            if (index === -1) {
                return null;
            }
            return invoiceVM.value.documentCheckList_Ext[index].sasriaForm;
        },
        [invoiceVM.value.documentCheckList_Ext]
    );

    const getDocumentType = useCallback(
        (index) => {
            if (index === -1) {
                return null;
            }
            return invoiceVM.value.documentCheckList_Ext[index].documentType;
        },
        [invoiceVM.value.documentCheckList_Ext]
    );

    const onUploadDocument = useCallback(
        async (file) => {
            setShowLoader(true);
            const invoiceDocuments = _.get(invoiceVM, 'documents.value', []);
            const fileName = FileUtil.checkFileName(file.name,
                [...existingDocuments, ...invoiceDocuments]);
            const documentMetaDataTemplate = {
                DocUID: fileName,
                serviceRequestId: serviceRequestID,
                name: fileName,
                description: getDescription(selectedIcon),
                DocumentType_EXT: getDocumentType(selectedIcon),
                sasriaDocumentForm_EXT: getDescription(selectedIcon),
                mimeType: getMimeType(file.name),
                visibleToVendor_EXT: true,
                vendorDocumentType_Ext: vendorDocumentType,
                sessionID: await ServiceRequestService.generateUploadToken(authHeader)
            };

            try {
                ServiceRequestService.uploadDocument(file, documentMetaDataTemplate, authHeader)
                    .then((data) => {
                        const existingDocumentsToLink = _.get(invoiceVM, 'existingDocumentsToLink.value', []);
                        // const newInvoiceVM = _.clone(invoiceVM);
                        _.set(invoiceVM, 'documents.value', [...invoiceDocuments, data]);
                        _.set(invoiceVM, 'existingDocumentsToLink.value', [...existingDocumentsToLink, data.publicID]);
                        updateUploadedDocuments(getDescription(selectedIcon), data.publicID);
                        // setInvoiceVM(newInvoiceVM);
                        refreshData();
                    }).catch(() => {
                        ModalNextProvider.showAlert({
                            title: messages.error,
                            message: messages.errorMessage,
                            status: 'error',
                            icon: 'mi-error-outline'
                        });
                    }).finally(() => {
                        setShowLoader(false);
                    });
            } catch (error) {
                setShowLoader(false);
                handleError(commonMessages.errorUploadTitle, commonMessages.uploadFailedMessage);
            }
        },
        [invoiceVM, existingDocuments, serviceRequestID, getDescription, selectedIcon, getDocumentType, getMimeType, vendorDocumentType, authHeader, updateUploadedDocuments, refreshData, handleError]
    );

    const onIconClicked = useCallback(
        (evt, index) => {
            if (index === selectedIcon) {
                setSelectedIcon(-1);
            } else {
                setSelectedIcon(index);
            }
        },
        [selectedIcon]
    );

    const getIconClass = useCallback(
        (index) => {
            if (index === selectedIcon) {
                return 'selected-icon';
            }
            return '';
        },
        [selectedIcon]
    );

    const getDocTypeIcon = useCallback(
        (docType) => {
            const iconName = _.get(iconMap, docType.sasriaForm);
            if (!_.isNil(iconName)) {
                return iconName;
            }
            return 'mi-attach-file';
        },
        [iconMap]
    );

    const getDocHeaderOnIconSelection = useCallback(
        (index) => {
            if (index === -1) {
                return null;
            }
            return uploadDocumentTypes[index].sasriaFormName;
        },
        [uploadDocumentTypes]
    );

    const generateIconOverrides = useCallback(() => {
        const documentTypes = _.get(invoiceVM.value, 'documentCheckList_Ext', []);
        const overrides = documentTypes.map((docType, index) => {
            return {
                [`documentIcon${index}`]: {
                    icon: getDocTypeIcon(docType),
                    onClick: (e) => {
                        onIconClicked(e, index);
                    },
                    tooltip: {
                        text: docType.sasriaFormName,
                        placement: 'bottom'
                    },
                    iconClassName: getIconClass(index)
                }
            };
        });
        return Object.assign({}, ...overrides);
    }, [getDocTypeIcon, getIconClass, invoiceVM, onIconClicked]);

    const overrides = {
        addtionalInformationLoader: {
            loaded: !showLoader
        },
        uploadDocumentGrid: {
            visible: !showLoader
        },
        uploadDocument: {
            visible: selectedIcon !== -1
        },
        addMoreInfoLabel: {
            visible: selectedIcon === -1
        },
        selectedIconDocName: {
            visible: selectedIcon !== -1,
            content: getDocHeaderOnIconSelection(selectedIcon)
        },
        ...generateMoreInfoDocumentsOverrides(),
        ...generateIconOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onUploadDocument: onUploadDocument
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={invoiceVM}
            overrideProps={overrides}
            onModelChange={refreshData}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

UploadComponent.propTypes = {
    path: PropTypes.shape({}).isRequired,
    authHeader: PropTypes.shape({}).isRequired,
    existingDocuments: PropTypes.arrayOf({}),
    uploadDocumentTypes: PropTypes.arrayOf({}),
    serviceRequestID: PropTypes.string,
};
UploadComponent.defaultProps = {
    existingDocuments: [],
    uploadDocumentTypes: [],
    serviceRequestID: undefined
};

export default withAuthenticationContext(UploadComponent);
